import { ArrowPathIcon, SparklesIcon } from "@heroicons/react/24/outline";
import { ClientAiSummaryState } from "components/ai-summary/use-client-ai-summary";
import { SecondaryCompactButton } from "components/ui/secondary-button";
import React from "react";

interface GenerateAiSummaryButtonProps {
    aiSummary: ClientAiSummaryState;
    clientName: string;
}

export const GenerateAiSummaryButton: React.FC<GenerateAiSummaryButtonProps> = props => {
    const { aiSummary, clientName } = props;

    if (aiSummary.summary || aiSummary.isQueryLoading || !clientName) {
        return null;
    }

    return (
        <SecondaryCompactButton
            onClick={aiSummary.generate}
            disabled={aiSummary.isLoading}
            className="flex-shrink-0 items-center space-x-1">
            {aiSummary.isGenerating ? (
                <ArrowPathIcon aria-hidden="true" className="h-3.5 w-3.5 animate-spin" />
            ) : (
                <SparklesIcon aria-hidden="true" className="h-3.5 w-3.5" />
            )}
            <span>Generate AI summary</span>
        </SecondaryCompactButton>
    );
};
